module.exports = __webpack_public_path__ + "img/电机评价平台.45ce0edd.png";